module.exports = __webpack_public_path__ + "static/img/0000趣拍拍.dd5a865.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0000趣拍拍.jpg
// module id = rY1N
// module chunks = 0